import { useStore } from "vuex";
import { isDocument, getDocumentIcon } from "foundation/js/utils/communityAttachmentUtils"

export default {
    name: "AttachmentsViewer",
    props: {
        files: {
            type: Array,
            required: true
        },
        showImagesAsFiles: {
            type: Boolean,
            default: false
        }
    },
    setup(props) {
        const store = useStore();

        const formatFileSize = size => {
            if (typeof size === "string") {
                return size
            }
            
            const sizeKB = size / 1024
            
            if (sizeKB < 1000) {
                return `${sizeKB.toFixed(1)} KB`   
            }
            
            const sizeMB = sizeKB / 1000
            return `${sizeMB.toFixed(3)} MB`
        }
        
        const getLabel = (labelKey) => store.getters['labels/getLabel']({labelCollection: 'AttachmentsViewer', labelKey})

        return {
            getLabel,
            getDocumentIcon,
            isDocument,
            formatFileSize
        }

    }
}